"use strict";
// @ts-ignore
try {
    self['workbox:window:7.2.0'] && _();
}
catch (e) { }
